import { ColDef, ColGroupDef, RowModelType } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { FC, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { PageButtonLink, usePageData } from "../../../_metronic/layout/core/PageData";

import { BaseAgGrid } from "./BaseAgGrid";
import { useLocation } from "react-router-dom";
import { SimpleEntityGridExternalFilterProps, SimpleEntityGridRest } from "./SimpleEntityGridRest";

export type SimpleEntityGridColumn = ColDef | ColGroupDef;
type ToolbarButtonAction = {
    export: boolean;
};

type EntityGridProps = {
    columns: Array<ColDef>;
    rowModelType?: RowModelType;
    listHandler: (params?: any) => any;
    totalFilteredHandle?: (params?: any) => any;
    totalRowsHandle?: (params?: any) => any;
    toolbarButtonAction?: ToolbarButtonAction;
};

export const EntityGrid: FC<EntityGridProps> = (props) => {
    const {
        columns,
        listHandler,
        toolbarButtonAction = { export: true },
        rowModelType,
        totalFilteredHandle,
        totalRowsHandle,
    } = props;
    const { formatMessage } = useIntl();
    const location = useLocation();
    const { pageTitle, setPageToolbarButtons } = usePageData();
    const gridRef = useRef<AgGridReact>(null);

    const resetGrid = () => {
        gridRef?.current?.api.setFilterModel({});
        gridRef?.current?.columnApi.resetColumnState();
        window.localStorage.removeItem(`${location.pathname}`);
    };
    const getGridToolbarButtons = () => {
        const currentPageToolbarButtons: Array<PageButtonLink> = [];

        if (toolbarButtonAction?.export) {
            const date = moment().format("YYYY-MM-DD");
            const pageTitleNoSpace = pageTitle?.replace(" ", "_");
            const currentFileName = `${pageTitleNoSpace} _${date}`;
            currentPageToolbarButtons.push({
                path: "#",
                title: `${formatMessage({ id: "common.action.export" })}`,
                onClick: () => {
                    gridRef?.current?.api.exportDataAsExcel({
                        fileName: currentFileName,
                        sheetName: pageTitleNoSpace,
                    });
                },
            });
        }
        currentPageToolbarButtons.push({
            path: "#",
            title: ``,
            renderComponent: SimpleEntityGridRest,
            renderComponentProps: {
                onChange: resetGrid,
            } as SimpleEntityGridExternalFilterProps,
        });

        return currentPageToolbarButtons;
    };

    useEffect(() => {
        setPageToolbarButtons(getGridToolbarButtons());
    }, [pageTitle]);

    return (
        <div className="ag-theme-balham" style={{ height: "100%" }}>
            <BaseAgGrid
                rowModelType={rowModelType}
                totalFilteredHandle={totalFilteredHandle}
                totalRowsHandle={totalRowsHandle}
                listHandler={listHandler}
                gridRef={gridRef}
                columnDefs={columns}
            />
        </div>
    );
};
